// Shared chart color vocabulary for report insight widgets — reuses the app's existing status-color
// families (see components/ui/Pill/pillColors.js) rather than introducing a new unrelated palette.
export const SERIES_COLORS = ["#006546", "#1d4ed8", "#92400e", "#b70000", "#5d35e9", "#626276"];

export const PRIMARY_COLOR = "#006546";
export const GRID_COLOR = "#eeeef0";
export const AXIS_TEXT_COLOR = "#626276";

export const colorForIndex = (index) => SERIES_COLORS[index % SERIES_COLORS.length];

export const formatCount = (value) => new Intl.NumberFormat("en-IE").format(value ?? 0);

export const formatCurrency = (value) =>
  new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR" }).format(value ?? 0);

export const formatPercent = (value) => `${Math.round(value ?? 0)}%`;

// Crops a long category label (doctor/drug/vaccine name, …) to maxChars, appending an ellipsis —
// callers pair this with a native `title` (or SVG <title>) so the full text is still available on hover.
export const truncateLabel = (label, maxChars) => {
  const text = String(label ?? "");
  return text.length > maxChars ? `${text.slice(0, maxChars - 1)}…` : text;
};
